export type SentenceResult = {
  text: string;
  is_ai: boolean;
  confidence: number;
};

export type DocumentAnalysisResult = {
  is_ai: boolean;
  confidence: number;
  model_family: string;
  model_version: string | null;
  word_count: number;
  sentence_count: number;
  sentences: SentenceResult[];
};

export type DocumentAnalysisStatus = 'queued' | 'processing' | 'complete' | 'failed';

export type DocumentAnalysisJob = {
  analysis_id: string;
  filename: string;
  content_type: string;
  status: DocumentAnalysisStatus;
  progress: number;
  error: string | null;
  result: DocumentAnalysisResult | null;
  created_at: string;
  updated_at: string;
};

export type DocumentAnalysisCreateResponse = {
  analysis_id: string;
  status: DocumentAnalysisStatus;
  progress: number;
};

async function parseJson<T>(response: Response): Promise<T> {
  if (!response.ok) {
    const payload = await response.json().catch(() => ({ detail: `Request failed: ${response.status}` }));
    throw new Error(payload.detail ?? `Request failed: ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export async function uploadDocument(file: File): Promise<DocumentAnalysisCreateResponse> {
  const formData = new FormData();
  formData.append('file', file);
  const response = await fetch('/api/v1/analyze/documents', {
    method: 'POST',
    body: formData,
  });
  return parseJson<DocumentAnalysisCreateResponse>(response);
}

export async function fetchDocumentAnalysis(analysisId: string): Promise<DocumentAnalysisJob> {
  const response = await fetch(`/api/v1/analyze/documents/${analysisId}`);
  return parseJson<DocumentAnalysisJob>(response);
}

export function getDocumentReportUrl(analysisId: string): string {
  return `/api/v1/analyze/documents/${analysisId}/report`;
}
